<div id="attachment-item-{{idPostfix()}}" class="flex-row justify-start items-center gap-2 flex flex-wrap">
  <div id="attachment-content-{{idPostfix()}}" (click)="handleImageClick(attachment().file_object.Content)"
       class="w-full">
    @if (extractExtension(attachment().file_url) != 'pdf' && isImage(attachment().file_url)) {
      <div id="attachment-image-container-{{idPostfix()}}"
           class="w-[250px] h-[250px] rounded-lg border border-gray-400 cursor-pointer">
        <img id="attachment-image-{{idPostfix()}}" [ngSrc]="attachment().file_object.Content"
             (error)="handleImageError($event)" width="250" height="250"
             alt="file" class="w-full h-full object-contain rounded-lg p-1">
      </div>
    }
    @if (!isImage(attachment().file_url)) {
      <div id="attachment-file-container-{{idPostfix()}}"
           class="w-[250px] h-[250px] rounded-lg border border-gray-400 bg-yellow-300">
        <div class="flex justify-center items-center h-full cursor-pointer">
          <span id="attachment-extension-{{idPostfix()}}" class="font-bold">
            {{ extractExtension(attachment().file_url).toUpperCase() }}
          </span>
        </div>
      </div>
    }
    <div id="attachment-info-{{idPostfix()}}" class="text-blue-500 text-sm font-semibold font-['Inter'] w-[250px]">
      <p id="attachment-filename-{{idPostfix()}}" class="w-[250px] truncate ..."
         title="{{ extractFileName(attachment().file_object.Content) }}">
        {{ extractFileName(attachment().file_object.Content) }}
      </p>
      <span id="attachment-device-{{idPostfix()}}" title="{{attachment().device}}"
            class="text-xs font-normal text-gray-700">
        {{ attachment().device }}
      </span>
      <span id="attachment-description-{{idPostfix()}}" title="{{attachment().description}}"
            class="text-xs font-normal text-gray-700 line-clamp-2">
        {{ attachment().description }}
      </span>
    </div>
  </div>
</div>
